(() => {
    const root = (window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
        '/';

    const $ = (s, c = document) => c.querySelector(s);
    const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

    /* =========================================================
       MONEY
    ========================================================= */

    const money = cents => {
        const format =
            window.LaffanTheme?.moneyFormat ||
            'QAR {{amount}}';

        const value =
            Number(cents || 0) / 100;

        const formatted =
            Number.isInteger(value)
                ? value.toLocaleString('en-US')
                : value.toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                });

        return format.replace(
            /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator)\s*\}\}/,
            formatted
        );
    };


    /* =========================================================
       HELPERS
    ========================================================= */

    const toast = message => {
        const el =
            $('#ThemeToast');

        if (!el)
            return;

        el.textContent =
            message;

        el.classList.add(
            'is-visible'
        );

        clearTimeout(
            window.__themeToast
        );

        window.__themeToast =
            setTimeout(
                () => {
                    el.classList.remove(
                        'is-visible'
                    );
                },
                1800
            );
    };


    const escapeHTML = value => {
        return String(
            value || ''
        )
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };


    const parseDisplayedPriceToCents = text => {
        if (!text)
            return 0;

        let clean =
            String(text)
                .replace(/QAR/gi, '')
                .replace(/[^\d.,]/g, '')
                .trim();

        if (!clean) {
            return 0;
        }

        if (
            clean.includes(',') &&
            clean.includes('.')
        ) {
            clean =
                clean.replace(
                    /,/g,
                    ''
                );
        } else if (
            clean.includes(',') &&
            !clean.includes('.')
        ) {
            const parts =
                clean.split(',');

            if (
                parts.length === 2 &&
                parts[1].length <= 2
            ) {
                clean =
                    parts[0] +
                    '.' +
                    parts[1];
            } else {
                clean =
                    clean.replace(
                        /,/g,
                        ''
                    );
            }
        }

        const value =
            Number(clean);

        if (
            !Number.isFinite(
                value
            )
        ) {
            return 0;
        }

        return Math.round(
            value * 100
        );
    };


    /* =========================================================
       CART DRAWER ITEM ACTION ROW
       Keep − qty + and Remove on the same line.
    ========================================================= */

    if (!document.getElementById('LaffanDrawerActionStyles')) {
        const drawerActionStyles =
            document.createElement('style');

        drawerActionStyles.id =
            'LaffanDrawerActionStyles';

        drawerActionStyles.textContent = `
          .cart-drawer .drawer-line__actions {
            width: 100% !important;
            margin-top: 8px !important;

            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 12px !important;

            direction: ltr !important;
          }

          .cart-drawer .drawer-line__actions .drawer-line__controls {
            margin: 0 !important;
            flex: 0 0 auto !important;
          }

          .cart-drawer .drawer-line__actions .drawer-line__remove {
            margin: 0 0 0 auto !important;
            padding: 4px 0 4px 10px !important;

            flex: 0 0 auto !important;
            align-self: center !important;

            line-height: 1.2 !important;
            white-space: nowrap !important;
          }

          html[dir="rtl"] .cart-drawer .drawer-line__actions {
            direction: rtl !important;
          }

          html[dir="rtl"] .cart-drawer .drawer-line__actions .drawer-line__remove {
            margin: 0 auto 0 0 !important;
            padding: 4px 10px 4px 0 !important;
          }

          @media screen and (max-width: 749px) {
            .cart-drawer .drawer-line__actions {
              gap: 8px !important;
              margin-top: 7px !important;
            }
          }
        `;

        document.head.appendChild(
            drawerActionStyles
        );
    }


    /* =========================================================
       CART DRAWER
    ========================================================= */

    const drawer =
        $('[data-cart-drawer]');

    const backdrop =
        $('[data-cart-backdrop]');


    const openDrawer = () => {
        if (!drawer)
            return;

        drawer.setAttribute(
            'aria-hidden',
            'false'
        );

        if (backdrop) {
            backdrop.hidden =
                false;
        }

        document.body
            .classList
            .add(
                'drawer-open'
            );
    };


    const closeDrawer = () => {
        if (!drawer)
            return;

        drawer.setAttribute(
            'aria-hidden',
            'true'
        );

        if (backdrop) {
            backdrop.hidden =
                true;
        }

        document.body
            .classList
            .remove(
                'drawer-open'
            );
    };


    $$('[data-cart-close]')
        .forEach(
            button => {
                button.addEventListener(
                    'click',
                    closeDrawer
                );
            }
        );


    backdrop?.addEventListener(
        'click',
        closeDrawer
    );


    document.addEventListener(
        'keydown',
        event => {
            if (
                event.key ===
                'Escape'
            ) {
                closeDrawer();
            }
        }
    );


    /* =========================================================
       CART COUNT
    ========================================================= */

    const updateCartCount = count => {
        $$('[data-cart-count]')
            .forEach(
                el => {
                    el.textContent =
                        Math.max(
                            0,
                            Number(
                                count || 0
                            )
                        );
                }
            );
    };


    const getCurrentCartCount = () => {
        const el =
            $('[data-cart-count]');

        return Number(
            el?.textContent ||
            0
        );
    };


    /* =========================================================
       GET CART
    ========================================================= */

    async function getCart() {
        const response =
            await fetch(
                root +
                'cart.js',
                {
                    headers: {
                        Accept:
                            'application/json'
                    }
                }
            );

        if (
            !response.ok
        ) {
            throw new Error(
                'Cart request failed'
            );
        }

        return response.json();
    }


    /* =========================================================
       PRODUCT CARD CART CONTROLS
       ADD TO CART -> MINUS / QUANTITY / PLUS
    ========================================================= */

    function setProductCardControl(
        control,
        quantity,
        lineKey = ''
    ) {
        if (!control)
            return;

        const addButton =
            control.querySelector(
                '[data-card-add]'
            );

        const quantityBox =
            control.querySelector(
                '[data-card-quantity]'
            );

        const quantityNumber =
            control.querySelector(
                '[data-card-quantity-number]'
            );

        const safeQuantity =
            Math.max(
                0,
                Number(
                    quantity || 0
                )
            );

        control.dataset.quantity =
            String(
                safeQuantity
            );

        control.dataset.lineKey =
            lineKey || '';

        if (quantityNumber) {
            quantityNumber.textContent =
                String(
                    safeQuantity
                );
        }

        if (
            safeQuantity > 0
        ) {
            if (addButton) {
                addButton.hidden =
                    true;
            }

            if (quantityBox) {
                quantityBox.hidden =
                    false;
            }
        } else {
            if (addButton) {
                addButton.hidden =
                    false;
            }

            if (quantityBox) {
                quantityBox.hidden =
                    true;
            }
        }
    }


    function syncProductCardControls(
        cart
    ) {
        if (
            !cart ||
            !Array.isArray(
                cart.items
            )
        ) {
            return;
        }

        $$('[data-card-cart-control]')
            .forEach(
                control => {
                    const variantId =
                        Number(
                            control.dataset.variantId ||
                            0
                        );

                    if (!variantId) {
                        return;
                    }

                    const matchingItems =
                        cart.items.filter(
                            item =>
                                Number(
                                    item.variant_id
                                ) ===
                                variantId
                        );

                    const quantity =
                        matchingItems.reduce(
                            (
                                total,
                                item
                            ) =>
                                total +
                                Number(
                                    item.quantity ||
                                    0
                                ),
                            0
                        );

                    const lineKey =
                        matchingItems[0]?.key ||
                        '';

                    setProductCardControl(
                        control,
                        quantity,
                        lineKey
                    );
                }
            );
    }


    async function changeCartLineByKey(
        lineKey,
        quantity
    ) {
        const response =
            await fetch(
                root +
                'cart/change.js',
                {
                    method:
                        'POST',

                    headers: {
                        'Content-Type':
                            'application/json',

                        Accept:
                            'application/json'
                    },

                    body:
                        JSON.stringify({
                            id:
                                String(
                                    lineKey
                                ),

                            quantity:
                                Math.max(
                                    0,
                                    Number(
                                        quantity || 0
                                    )
                                )
                        })
                }
            );

        const data =
            await response.json();

        if (
            !response.ok
        ) {
            throw new Error(
                data.description ||
                'Unable to update cart'
            );
        }

        return data;
    }


    /* =========================================================
       CART STATE
    ========================================================= */

    const cartLineStates =
        new Map();

    /*
      IMPORTANT:
      Used to stop OLD Shopify responses
      from overwriting NEW customer quantity.
    */

    let cartUiRevision =
        0;


    function markCartUiChanged() {
        cartUiRevision++;
    }


    /* =========================================================
       REFRESH REAL CART
    ========================================================= */

    async function refreshCart() {
        const requestRevision =
            cartUiRevision;

        try {
            const cart =
                await getCart();

            if (
                requestRevision !==
                cartUiRevision
            ) {
                return cart;
            }

            updateCartCount(
                cart.item_count
            );

            syncProductCardControls(
                cart
            );

            const body =
                $('[data-cart-drawer-body]');

            const footer =
                $('[data-cart-drawer-footer]');

            const total =
                $('[data-cart-total]');

            if (
                !body ||
                !footer
            ) {
                return cart;
            }

            if (
                !cart.items.length
            ) {
                body.innerHTML =
                    `<p class="muted">${
                        window.LaffanTheme
                            ?.strings
                            ?.cartEmpty ||
                        'Your cart is empty'
                    }</p>`;

                footer.hidden =
                    true;

                cartLineStates.clear();

                return cart;
            }

            body.innerHTML =
                cart.items
                    .map(
                        (item, index) => `

<div
  class="drawer-line"
  data-line="${index + 1}"
  data-item-qty="${item.quantity}"
  data-item-price="${item.final_price}"
>

  <a href="${item.url}">

    ${
        item.image
            ? `<img src="${item.image}" alt="">`
            : ''
    }

  </a>


  <div class="drawer-line__info">

    <a
      class="drawer-line__title"
      href="${item.url}"
    >
      ${item.product_title}
    </a>


    ${
        item.variant_title &&
        item.variant_title !==
            'Default Title'

            ? `<span class="drawer-line__variant">
            ${item.variant_title}
           </span>`

            : ''
    }


    <strong
      data-drawer-line-price
    >
      ${money(
          item.final_line_price
      )}
    </strong>


    <div
      class="drawer-line__actions"
    >

      <div
        class="drawer-line__controls"
      >

        <button
          type="button"
          data-drawer-minus
          aria-label="Decrease quantity"
        >
          −
        </button>


        <span
          data-drawer-current-qty
        >
          ${item.quantity}
        </span>


        <button
          type="button"
          data-drawer-plus
          aria-label="Increase quantity"
        >
          +
        </button>

      </div>


      <button
        class="drawer-line__remove"
        type="button"
        data-drawer-remove
      >

        ${
            window.LaffanTheme
                ?.strings
                ?.remove ||
            'Remove'
        }

      </button>

    </div>

  </div>

</div>

`
                    )
                    .join('');

            if (total) {
                total.textContent =
                    money(
                        cart.total_price
                    );
            }

            footer.hidden =
                false;

            cartLineStates.clear();

            return cart;

        } catch (error) {
            console.error(
                error
            );
        }
    }


    /* =========================================================
       OPTIMISTIC NEW ITEM
    ========================================================= */

    function renderOptimisticItem({
        title,
        image,
        price,
        quantity,
        url,
        variantTitle
    }) {
        const body =
            $('[data-cart-drawer-body]');

        const footer =
            $('[data-cart-drawer-footer]');

        if (!body) {
            return null;
        }

        const empty =
            body.querySelector(
                '.muted'
            );

        if (empty) {
            empty.remove();
        }

        const optimistic =
            document.createElement(
                'div'
            );

        optimistic.className =
            'drawer-line drawer-line--optimistic';

        optimistic.setAttribute(
            'data-optimistic-line',
            'true'
        );

        optimistic.innerHTML = `

<a href="${escapeHTML(url || '#')}">

  ${
      image
          ? `<img
           src="${escapeHTML(image)}"
           alt=""
         >`
          : ''
  }

</a>


<div class="drawer-line__info">

  <a
    class="drawer-line__title"
    href="${escapeHTML(url || '#')}"
  >
    ${escapeHTML(
        title ||
        'Product'
    )}
  </a>


  ${
      variantTitle &&
      variantTitle !==
          'Default Title'

          ? `<span
           class="drawer-line__variant"
         >
           ${escapeHTML(
               variantTitle
           )}
         </span>`

          : ''
  }


  <strong
    data-drawer-line-price
  >
    ${money(
        Number(
            price || 0
        ) *
        Number(
            quantity || 1
        )
    )}
  </strong>


  <div
    class="drawer-line__controls"
    style="opacity:.65"
  >

    <button
      type="button"
      disabled
    >
      −
    </button>

    <span>
      ${Number(
          quantity || 1
      )}
    </span>

    <button
      type="button"
      disabled
    >
      +
    </button>

  </div>


  <small
    style="
      color:var(--primary);
      font-weight:800;
    "
  >
    Added ✓
  </small>

</div>

`;

        optimistic.style.opacity =
            '0';

        optimistic.style.transform =
            'translateY(-5px)';

        optimistic.style.transition =
            'opacity .15s ease, transform .15s ease';

        body.prepend(
            optimistic
        );

        if (footer) {
            footer.hidden =
                false;
        }

        requestAnimationFrame(
            () => {
                optimistic.style.opacity =
                    '1';

                optimistic.style.transform =
                    'translateY(0)';
            }
        );

        return optimistic;
    }


    function removeOptimisticItem(
        element
    ) {
        if (
            element &&
            element.isConnected
        ) {
            element.remove();
        }
    }


    /* =========================================================
       GET PRODUCT DATA
    ========================================================= */

    function getProductFormData(
        form,
        variantId,
        quantity,
        variants
    ) {
        const productInfo =
            form.closest(
                '.product-info'
            ) ||
            document;

        const title =
            $('.product-info h1')
                ?.textContent
                ?.trim() ||
            $('h1', productInfo)
                ?.textContent
                ?.trim() ||
            document.title;

        const selectedVariant =
            Array.isArray(
                variants
            )
                ? variants.find(
                    v =>
                        String(
                            v.id
                        ) ===
                        String(
                            variantId
                        )
                )
                : null;

        const price =
            selectedVariant?.price ??
            parseDisplayedPriceToCents(
                $('[data-product-price]')
                    ?.textContent ||
                $('.product-price')
                    ?.textContent ||
                ''
            );

        const mainImage =
            $('.product-gallery__item img') ||
            $('.product-gallery img');

        const image =
            selectedVariant
                ?.featured_image
                ?.src ||
            selectedVariant
                ?.featured_image ||
            mainImage
                ?.currentSrc ||
            mainImage
                ?.src ||
            '';

        const variantTitle =
            selectedVariant?.title &&
            selectedVariant.title !==
                'Default Title'
                ? selectedVariant.title
                : '';

        return {
            title,
            image,
            price,
            quantity,

            url:
                location.pathname +
                `?variant=${variantId}`,

            variantTitle
        };
    }


    function getQuickAddData(
        button
    ) {
        const card =
            button.closest(
                '.product-card'
            );

        const title =
            card
                ?.querySelector(
                    '.product-card__title'
                )
                ?.textContent
                ?.trim() ||
            'Product';

        const imageEl =
            card
                ?.querySelector(
                    '.product-card__media img'
                );

        const image =
            imageEl?.currentSrc ||
            imageEl?.src ||
            '';

        const priceText =
            card
                ?.querySelector(
                    '.price'
                )
                ?.textContent ||
            '';

        const price =
            parseDisplayedPriceToCents(
                priceText
            );

        const productLink =
            card
                ?.querySelector(
                    'a'
                )
                ?.href ||
            '#';

        return {
            title,
            image,
            price,
            quantity:
                1,
            url:
                productLink,
            variantTitle:
                ''
        };
    }


    /* =========================================================
       ADD VARIANT
    ========================================================= */

    async function addVariant(
        id,
        quantity = 1
    ) {
        const response =
            await fetch(
                root +
                'cart/add.js',
                {
                    method:
                        'POST',

                    headers: {
                        'Content-Type':
                            'application/json',

                        Accept:
                            'application/json'
                    },

                    body:
                        JSON.stringify({
                            items: [
                                {
                                    id:
                                        Number(
                                            id
                                        ),

                                    quantity:
                                        Number(
                                            quantity
                                        )
                                }
                            ]
                        })
                }
            );

        const data =
            await response.json();

        if (
            !response.ok
        ) {
            throw new Error(
                data.description ||
                'Unable to add item'
            );
        }

        return data;
    }


    /* =========================================================
       OPEN CART
    ========================================================= */

    $$('[data-cart-open]')
        .forEach(
            button => {
                button.addEventListener(
                    'click',
                    () => {
                        openDrawer();

                        refreshCart();
                    }
                );
            }
        );


    /* =========================================================
       CART LINE STATE
    ========================================================= */

    function getCartLineState(
        line,
        quantity
    ) {
        line =
            Number(
                line
            );

        if (
            !cartLineStates.has(
                line
            )
        ) {
            cartLineStates.set(
                line,
                {
                    desiredQuantity:
                        Number(
                            quantity ||
                            0
                        ),

                    timer:
                        null,

                    syncing:
                        false
                }
            );
        }

        return cartLineStates.get(
            line
        );
    }


    /* =========================================================
       INSTANT QUANTITY UI
    ========================================================= */

    function updateDrawerLineInstant(
        lineElement,
        quantity
    ) {
        if (!lineElement) {
            return;
        }

        const qtyElement =
            lineElement.querySelector(
                '[data-drawer-current-qty]'
            );

        const priceElement =
            lineElement.querySelector(
                '[data-drawer-line-price]'
            );

        const unitPrice =
            Number(
                lineElement.dataset
                    .itemPrice ||
                0
            );

        lineElement.dataset
            .itemQty =
            String(
                quantity
            );

        if (qtyElement) {
            qtyElement.textContent =
                quantity;
        }

        if (priceElement) {
            priceElement.textContent =
                money(
                    unitPrice *
                    quantity
                );
        }
    }


    /* =========================================================
       SYNC CART LINE
       OLD RESPONSES ARE IGNORED
    ========================================================= */

    async function syncCartLine(
        line
    ) {
        const state =
            cartLineStates.get(
                line
            );

        if (
            !state ||
            state.syncing
        ) {
            return;
        }

        state.syncing =
            true;

        const quantityToSend =
            state.desiredQuantity;

        try {
            const response =
                await fetch(
                    root +
                    'cart/change.js',
                    {
                        method:
                            'POST',

                        headers: {
                            'Content-Type':
                                'application/json',

                            Accept:
                                'application/json'
                        },

                        body:
                            JSON.stringify({
                                line:
                                    Number(
                                        line
                                    ),

                                quantity:
                                    Number(
                                        quantityToSend
                                    )
                            })
                    }
                );

            if (
                !response.ok
            ) {
                throw new Error(
                    'Cart update failed'
                );
            }

            const cart =
                await response.json();

            const latestState =
                cartLineStates.get(
                    line
                );

            if (
                latestState &&
                Number(
                    latestState
                        .desiredQuantity
                ) !==
                Number(
                    quantityToSend
                )
            ) {
                return;
            }

            updateCartCount(
                cart.item_count
            );

            const total =
                $('[data-cart-total]');

            if (total) {
                total.textContent =
                    money(
                        cart.total_price
                    );
            }

            if (
                quantityToSend ===
                0
            ) {
                cartUiRevision++;

                const refreshRevision =
                    cartUiRevision;

                const cartAfterRemove =
                    await getCart();

                if (
                    refreshRevision ===
                    cartUiRevision
                ) {
                    renderCartFromData(
                        cartAfterRemove
                    );
                }

                return;
            }

            const serverItem =
                cart.items[
                    Number(
                        line
                    ) -
                    1
                ];

            if (!serverItem) {
                cartUiRevision++;

                const refreshRevision =
                    cartUiRevision;

                const realCart =
                    await getCart();

                if (
                    refreshRevision ===
                    cartUiRevision
                ) {
                    renderCartFromData(
                        realCart
                    );
                }

                return;
            }

            if (
                Number(
                    serverItem.quantity
                ) !==
                Number(
                    quantityToSend
                )
            ) {
                const latest =
                    cartLineStates.get(
                        line
                    );

                if (
                    latest &&
                    Number(
                        latest.desiredQuantity
                    ) ===
                    Number(
                        quantityToSend
                    )
                ) {
                    const lineElement =
                        $(
                            `[data-cart-drawer-body] [data-line="${line}"]`
                        );

                    if (lineElement) {
                        lineElement.dataset
                            .itemQty =
                            String(
                                serverItem.quantity
                            );

                        const qtyElement =
                            lineElement
                                .querySelector(
                                    '[data-drawer-current-qty]'
                                );

                        const priceElement =
                            lineElement
                                .querySelector(
                                    '[data-drawer-line-price]'
                                );

                        if (qtyElement) {
                            qtyElement.textContent =
                                serverItem.quantity;
                        }

                        if (priceElement) {
                            priceElement.textContent =
                                money(
                                    serverItem
                                        .final_line_price
                                );
                        }
                    }
                }

                return;
            }

            const lineElement =
                $(
                    `[data-cart-drawer-body] [data-line="${line}"]`
                );

            if (lineElement) {
                lineElement.dataset
                    .itemPrice =
                    String(
                        serverItem
                            .final_price
                    );

                lineElement.dataset
                    .itemQty =
                    String(
                        quantityToSend
                    );

                const priceElement =
                    lineElement
                        .querySelector(
                            '[data-drawer-line-price]'
                        );

                if (priceElement) {
                    priceElement.textContent =
                        money(
                            serverItem
                                .final_line_price
                        );
                }
            }

        } catch (error) {
            console.error(
                error
            );

            const currentRevision =
                ++cartUiRevision;

            try {
                const realCart =
                    await getCart();

                if (
                    currentRevision ===
                    cartUiRevision
                ) {
                    renderCartFromData(
                        realCart
                    );
                }

            } catch (e) {
                console.error(
                    e
                );
            }

        } finally {
            const currentState =
                cartLineStates.get(
                    line
                );

            if (currentState) {
                currentState.syncing =
                    false;

                if (
                    Number(
                        currentState
                            .desiredQuantity
                    ) !==
                    Number(
                        quantityToSend
                    )
                ) {
                    setTimeout(
                        () =>
                            syncCartLine(
                                line
                            ),
                        0
                    );
                }
            }
        }
    }


    /* =========================================================
       RENDER CART FROM ALREADY-RETURNED DATA
    ========================================================= */

    function renderCartFromData(
        cart
    ) {
        if (!cart)
            return;

        updateCartCount(
            cart.item_count
        );

        syncProductCardControls(
            cart
        );

        const body =
            $('[data-cart-drawer-body]');

        const footer =
            $('[data-cart-drawer-footer]');

        const total =
            $('[data-cart-total]');

        if (
            !body ||
            !footer
        ) {
            return;
        }

        if (
            !cart.items.length
        ) {
            body.innerHTML =
                `<p class="muted">${
                    window.LaffanTheme
                        ?.strings
                        ?.cartEmpty ||
                    'Your cart is empty'
                }</p>`;

            footer.hidden =
                true;

            cartLineStates.clear();

            return;
        }

        body.innerHTML =
            cart.items
                .map(
                    (item, index) => `

<div
  class="drawer-line"
  data-line="${index + 1}"
  data-item-qty="${item.quantity}"
  data-item-price="${item.final_price}"
>

  <a href="${item.url}">

    ${
        item.image
            ? `<img src="${item.image}" alt="">`
            : ''
    }

  </a>


  <div class="drawer-line__info">

    <a
      class="drawer-line__title"
      href="${item.url}"
    >
      ${item.product_title}
    </a>


    ${
        item.variant_title &&
        item.variant_title !==
            'Default Title'

            ? `<span class="drawer-line__variant">
            ${item.variant_title}
           </span>`

            : ''
    }


    <strong
      data-drawer-line-price
    >
      ${money(
          item.final_line_price
      )}
    </strong>


    <div
      class="drawer-line__actions"
    >

      <div
        class="drawer-line__controls"
      >

        <button
          type="button"
          data-drawer-minus
        >
          −
        </button>

        <span
          data-drawer-current-qty
        >
          ${item.quantity}
        </span>

        <button
          type="button"
          data-drawer-plus
        >
          +
        </button>

      </div>


      <button
        class="drawer-line__remove"
        type="button"
        data-drawer-remove
      >

        ${
            window.LaffanTheme
                ?.strings
                ?.remove ||
            'Remove'
        }

      </button>

    </div>

  </div>

</div>

`
                )
                .join('');

        if (total) {
            total.textContent =
                money(
                    cart.total_price
                );
        }

        footer.hidden =
            false;

        cartLineStates.clear();
    }


    /* =========================================================
       SCHEDULE CART LINE
    ========================================================= */

    function scheduleCartLineSync(
        line,
        quantity
    ) {
        line =
            Number(
                line
            );

        quantity =
            Math.max(
                0,
                Number(
                    quantity
                )
            );

        const state =
            getCartLineState(
                line,
                quantity
            );

        state.desiredQuantity =
            quantity;

        if (
            state.timer
        ) {
            clearTimeout(
                state.timer
            );
        }

        state.timer =
            setTimeout(
                () => {
                    state.timer =
                        null;

                    syncCartLine(
                        line
                    );
                },
                70
            );
    }


    /* =========================================================
       DRAWER PLUS / MINUS / REMOVE
    ========================================================= */

    document.addEventListener(
        'click',
        event => {
            const plus =
                event.target.closest(
                    '[data-drawer-plus]'
                );

            const minus =
                event.target.closest(
                    '[data-drawer-minus]'
                );

            const remove =
                event.target.closest(
                    '[data-drawer-remove]'
                );

            if (
                !plus &&
                !minus &&
                !remove
            ) {
                return;
            }

            event.preventDefault();

            const lineElement =
                event.target.closest(
                    '.drawer-line[data-line]'
                );

            if (!lineElement) {
                return;
            }

            const line =
                Number(
                    lineElement
                        .dataset
                        .line
                );

            const currentQuantity =
                Number(
                    lineElement
                        .dataset
                        .itemQty ||
                    0
                );

            let nextQuantity =
                currentQuantity;

            if (plus) {
                nextQuantity =
                    currentQuantity +
                    1;
            }

            if (minus) {
                nextQuantity =
                    Math.max(
                        0,
                        currentQuantity -
                        1
                    );
            }

            if (remove) {
                nextQuantity =
                    0;
            }

            if (
                nextQuantity ===
                currentQuantity
            ) {
                return;
            }

            markCartUiChanged();

            const state =
                getCartLineState(
                    line,
                    currentQuantity
                );

            state.desiredQuantity =
                nextQuantity;

            if (
                remove ||
                nextQuantity ===
                0
            ) {
                lineElement.style.height =
                    lineElement.offsetHeight +
                    'px';

                lineElement.style.overflow =
                    'hidden';

                lineElement.style.transition =
                    'opacity .12s ease, height .18s ease, margin .18s ease, padding .18s ease';

                requestAnimationFrame(
                    () => {
                        lineElement.style.opacity =
                            '0';

                        lineElement.style.height =
                            '0';

                        lineElement.style.marginTop =
                            '0';

                        lineElement.style.marginBottom =
                            '0';

                        lineElement.style.paddingTop =
                            '0';

                        lineElement.style.paddingBottom =
                            '0';
                    }
                );

                setTimeout(
                    () => {
                        if (
                            lineElement
                                .isConnected
                        ) {
                            lineElement.remove();
                        }
                    },
                    190
                );

            } else {
                updateDrawerLineInstant(
                    lineElement,
                    nextQuantity
                );
            }

            scheduleCartLineSync(
                line,
                nextQuantity
            );
        }
    );


    /* =========================================================
       PRODUCT CARD
       ULTRA FAST OPTIMISTIC QUANTITY
       OLD SHOPIFY RESPONSES NEVER OVERWRITE NEW UI
    ========================================================= */

    const productCardStates =
        new WeakMap();


    function getProductCardState(
        control
    ) {

        if (
            !productCardStates.has(
                control
            )
        ) {

            productCardStates.set(
                control,
                {

                    revision:
                        0,

                    desiredQuantity:
                        Number(
                            control.dataset.quantity ||
                            0
                        ),

                    syncing:
                        false,

                    timer:
                        null

                }
            );

        }


        return productCardStates.get(
            control
        );

    }



    function updateProductCardInstant(
        control,
        quantity
    ) {

        const safeQuantity =
            Math.max(
                0,
                Number(
                    quantity || 0
                )
            );


        control.dataset.quantity =
            String(
                safeQuantity
            );


        const addButton =
            control.querySelector(
                '[data-card-add]'
            );


        const quantityBox =
            control.querySelector(
                '[data-card-quantity]'
            );


        const number =
            control.querySelector(
                '[data-card-quantity-number]'
            );


        if (number) {

            number.textContent =
                String(
                    safeQuantity
                );

        }


        if (
            safeQuantity > 0
        ) {

            if (addButton) {

                addButton.hidden =
                    true;

            }


            if (quantityBox) {

                quantityBox.hidden =
                    false;

            }

        } else {

            if (addButton) {

                addButton.hidden =
                    false;

            }


            if (quantityBox) {

                quantityBox.hidden =
                    true;

            }

        }

    }



    async function syncSingleProductCard(
        control
    ) {

        const state =
            getProductCardState(
                control
            );


        if (
            state.syncing
        ) {

            return;

        }


        state.syncing =
            true;


        const revisionToSend =
            state.revision;


        const desiredQuantity =
            state.desiredQuantity;


        const variantId =
            Number(
                control.dataset.variantId ||
                0
            );


        if (!variantId) {

            state.syncing =
                false;

            return;

        }


        try {

            let cart =
                await getCart();


            if (
                revisionToSend !==
                state.revision
            ) {

                return;

            }


            const item =
                cart.items.find(
                    item =>
                        Number(
                            item.variant_id
                        ) ===
                        variantId
                );


            if (
                !item &&
                desiredQuantity > 0
            ) {

                await addVariant(
                    variantId,
                    desiredQuantity
                );


                cart =
                    await getCart();

            }


            else if (item) {

                cart =
                    await changeCartLineByKey(
                        item.key,
                        desiredQuantity
                    );

            }


            if (
                revisionToSend !==
                state.revision
            ) {

                return;

            }


            updateCartCount(
                cart.item_count
            );


            const total =
                $('[data-cart-total]');


            if (total) {

                total.textContent =
                    money(
                        cart.total_price
                    );

            }


            const freshItem =
                cart.items.find(
                    item =>
                        Number(
                            item.variant_id
                        ) ===
                        variantId
                );


            control.dataset.lineKey =
                freshItem?.key ||
                '';


        } catch (error) {

            console.error(
                error
            );


            if (
                revisionToSend ===
                state.revision
            ) {

                toast(
                    error.message ||
                    'Unable to update cart'
                );


                try {

                    const realCart =
                        await getCart();


                    const realItem =
                        realCart.items.find(
                            item =>
                                Number(
                                    item.variant_id
                                ) ===
                                variantId
                        );


                    const realQuantity =
                        Number(
                            realItem?.quantity ||
                            0
                        );


                    state.desiredQuantity =
                        realQuantity;


                    updateProductCardInstant(
                        control,
                        realQuantity
                    );


                    updateCartCount(
                        realCart.item_count
                    );


                    control.dataset.lineKey =
                        realItem?.key ||
                        '';


                } catch (refreshError) {

                    console.error(
                        refreshError
                    );

                }

            }


        } finally {

            state.syncing =
                false;


            if (
                revisionToSend !==
                state.revision
            ) {

                setTimeout(
                    () => {

                        syncSingleProductCard(
                            control
                        );

                    },
                    0
                );

            }

        }

    }



    function scheduleProductCardSync(
        control
    ) {

        const state =
            getProductCardState(
                control
            );


        if (
            state.timer
        ) {

            clearTimeout(
                state.timer
            );

        }


        state.timer =
            setTimeout(
                () => {

                    state.timer =
                        null;


                    syncSingleProductCard(
                        control
                    );

                },
                90
            );

    }



    document.addEventListener(
        'click',
        event => {


            const addButton =
                event.target.closest(
                    '[data-card-add]'
                );


            const plusButton =
                event.target.closest(
                    '[data-card-plus]'
                );


            const minusButton =
                event.target.closest(
                    '[data-card-minus]'
                );


            if (
                !addButton &&
                !plusButton &&
                !minusButton
            ) {

                return;

            }


            const control =
                event.target.closest(
                    '[data-card-cart-control]'
                );


            if (!control) {

                return;

            }


            event.preventDefault();

            event.stopPropagation();


            const state =
                getProductCardState(
                    control
                );


            const currentQuantity =
                Number(
                    state.desiredQuantity ||
                    0
                );


            let nextQuantity =
                currentQuantity;


            if (addButton) {

                nextQuantity =
                    1;

            }


            if (plusButton) {

                nextQuantity =
                    currentQuantity +
                    1;

            }


            if (minusButton) {

                nextQuantity =
                    Math.max(
                        0,
                        currentQuantity -
                        1
                    );

            }


            if (
                nextQuantity ===
                currentQuantity
            ) {

                return;

            }


            state.revision++;


            state.desiredQuantity =
                nextQuantity;


            updateProductCardInstant(
                control,
                nextQuantity
            );


            const difference =
                nextQuantity -
                currentQuantity;


            updateCartCount(
                Math.max(
                    0,
                    getCurrentCartCount() +
                    difference
                )
            );


            scheduleProductCardSync(
                control
            );

        }
    );


    /* =========================================================
       PRODUCT FORM
    ========================================================= */

    $$('[data-product-form]')
        .forEach(
            form => {
                const variantsElement =
                    $('[data-product-json]');

                let variants =
                    [];

                if (
                    variantsElement
                ) {
                    try {
                        variants =
                            JSON.parse(
                                variantsElement
                                    .textContent
                            );
                    } catch (error) {
                        variants =
                            [];
                    }
                }

                form.addEventListener(
                    'submit',
                    async event => {
                        event.preventDefault();

                        const id =
                            $(
                                '[data-variant-id]',
                                form
                            )?.value;

                        const quantity =
                            Number(
                                $(
                                    '[name="quantity"]',
                                    form
                                )?.value ||
                                1
                            );

                        const submit =
                            $(
                                '[type="submit"][name="add"]',
                                form
                            );

                        if (!id) {
                            return;
                        }

                        const oldText =
                            submit?.textContent ||
                            'Add to cart';

                        const optimisticData =
                            getProductFormData(
                                form,
                                id,
                                quantity,
                                variants
                            );

                        const optimisticElement =
                            renderOptimisticItem(
                                optimisticData
                            );

                        updateCartCount(
                            getCurrentCartCount() +
                            quantity
                        );

                        if (submit) {
                            submit.textContent =
                                'Added ✓';

                            submit.disabled =
                                true;
                        }

                        if (
                            window.LaffanTheme
                                ?.showCartDrawer !==
                            false
                        ) {
                            openDrawer();
                        }

                        try {
                            await addVariant(
                                id,
                                quantity
                            );

                            await refreshCart();

                        } catch (error) {
                            removeOptimisticItem(
                                optimisticElement
                            );

                            toast(
                                error.message
                            );

                            await refreshCart();

                            if (submit) {
                                submit.textContent =
                                    oldText;

                                submit.disabled =
                                    false;
                            }

                            return;
                        }

                        setTimeout(
                            () => {
                                if (submit) {
                                    submit.textContent =
                                        oldText;

                                    submit.disabled =
                                        false;
                                }
                            },
                            700
                        );
                    }
                );

                if (
                    !variantsElement
                ) {
                    return;
                }

                const inputs =
                    $$(
                        'input[name^="options["]',
                        form
                    );

                inputs.forEach(
                    input => {
                        input.addEventListener(
                            'change',
                            () => {
                                const names =
                                    [
                                        ...new Set(
                                            inputs.map(
                                                i =>
                                                    i.name
                                            )
                                        )
                                    ];

                                const selected =
                                    names.map(
                                        name =>
                                            $(
                                                `input[name="${CSS.escape(name)}"]:checked`,
                                                form
                                            )?.value
                                    );

                                const variant =
                                    variants.find(
                                        v =>
                                            v.options.every(
                                                (
                                                    option,
                                                    i
                                                ) =>
                                                    option ===
                                                    selected[i]
                                            )
                                    );

                                if (!variant) {
                                    return;
                                }

                                const idInput =
                                    $(
                                        '[data-variant-id]',
                                        form
                                    );

                                if (idInput) {
                                    idInput.value =
                                        variant.id;
                                }

                                const price =
                                    $(
                                        '[data-product-price]'
                                    );

                                if (price) {
                                    price.textContent =
                                        money(
                                            variant.price
                                        );
                                }

                                const submit =
                                    $(
                                        '[type="submit"][name="add"]',
                                        form
                                    );

                                if (submit) {
                                    submit.disabled =
                                        !variant.available;
                                }

                                history.replaceState(
                                    {},
                                    '',
                                    `${location.pathname}?variant=${variant.id}`
                                );
                            }
                        );
                    }
                );
            }
        );


    /* =========================================================
       PRODUCT QUANTITY
    ========================================================= */

    $$('[data-qty-minus]')
        .forEach(
            button => {
                button.addEventListener(
                    'click',
                    () => {
                        const input =
                            button.parentElement
                                .querySelector(
                                    'input'
                                );

                        input.value =
                            Math.max(
                                1,
                                Number(
                                    input.value ||
                                    1
                                ) -
                                1
                            );
                    }
                );
            }
        );


    $$('[data-qty-plus]')
        .forEach(
            button => {
                button.addEventListener(
                    'click',
                    () => {
                        const input =
                            button.parentElement
                                .querySelector(
                                    'input'
                                );

                        input.value =
                            Number(
                                input.value ||
                                1
                            ) +
                            1;
                    }
                );
            }
        );


    /* =========================================================
       CART PAGE QUANTITY
    ========================================================= */

    $$('[data-cart-page-minus]')
        .forEach(
            button => {
                button.addEventListener(
                    'click',
                    () => {
                        const input =
                            button.parentElement
                                .querySelector(
                                    'input'
                                );

                        input.value =
                            Math.max(
                                0,
                                Number(
                                    input.value ||
                                    0
                                ) -
                                1
                            );
                    }
                );
            }
        );


    $$('[data-cart-page-plus]')
        .forEach(
            button => {
                button.addEventListener(
                    'click',
                    () => {
                        const input =
                            button.parentElement
                                .querySelector(
                                    'input'
                                );

                        input.value =
                            Number(
                                input.value ||
                                0
                            ) +
                            1;
                    }
                );
            }
        );


    /* =========================================================
       MOBILE MENU
    ========================================================= */

    $$('[data-menu-toggle]')
        .forEach(
            button => {
                button.addEventListener(
                    'click',
                    () => {
                        const menu =
                            $('[data-mobile-menu]');

                        if (menu) {
                            menu.hidden =
                                !menu.hidden;
                        }
                    }
                );
            }
        );


    /* =========================================================
       SEARCH FOCUS
    ========================================================= */

    $$('[data-search-focus]')
        .forEach(
            button => {
                button.addEventListener(
                    'click',
                    () => {
                        const input =
                            $('#HeaderSearch');

                        if (input) {
                            window.scrollTo({
                                top:
                                    0,

                                behavior:
                                    'smooth'
                            });

                            setTimeout(
                                () =>
                                    input.focus(),
                                250
                            );
                        }
                    }
                );
            }
        );


    /* =========================================================
       PREDICTIVE SEARCH
    ========================================================= */

    const searchInput =
        $('[data-predictive-search-input]');

    const searchResults =
        $('[data-predictive-search-results]');

    let searchTimer;

    if (
        searchInput &&
        searchResults
    ) {
        searchInput.addEventListener(
            'input',
            () => {
                clearTimeout(
                    searchTimer
                );

                const query =
                    searchInput.value
                        .trim();

                if (
                    query.length <
                    2
                ) {
                    searchResults.hidden =
                        true;

                    searchResults.innerHTML =
                        '';

                    return;
                }

                searchTimer =
                    setTimeout(
                        async () => {
                            try {
                                const url =
                                    `${root}search/suggest?q=${encodeURIComponent(query)}` +
                                    `&resources[type]=product&resources[limit]=6&section_id=predictive-search`;

                                const response =
                                    await fetch(
                                        url
                                    );

                                const html =
                                    await response.text();

                                const documentResult =
                                    new DOMParser()
                                        .parseFromString(
                                            html,
                                            'text/html'
                                        );

                                const section =
                                    documentResult
                                        .querySelector(
                                            '#shopify-section-predictive-search'
                                        );

                                searchResults.innerHTML =
                                    section
                                        ? section.innerHTML
                                        : html;

                                searchResults.hidden =
                                    searchResults
                                        .textContent
                                        .trim() === '';

                            } catch (error) {
                                console.error(
                                    error
                                );
                            }
                        },
                        180
                    );
            }
        );

        document.addEventListener(
            'click',
            event => {
                if (
                    !event.target.closest(
                        '[data-predictive-search-form]'
                    )
                ) {
                    searchResults.hidden =
                        true;
                }
            }
        );
    }


    /* =========================================================
       PRELOAD CART
    ========================================================= */

    refreshCart();

})();



/* =========================================================
   PRODUCT GALLERY DOT NAVIGATION
========================================================= */

(() => {
    document
        .querySelectorAll(
            '.product-gallery'
        )
        .forEach(
            gallery => {
                const track =
                    gallery.querySelector(
                        '.product-gallery__main'
                    );

                const slides =
                    Array.from(
                        gallery.querySelectorAll(
                            '.product-gallery__item'
                        )
                    );

                if (
                    !track ||
                    slides.length <
                    2 ||
                    gallery.querySelector(
                        '.product-gallery__dots'
                    )
                ) {
                    return;
                }

                const dots =
                    document.createElement(
                        'div'
                    );

                dots.className =
                    'product-gallery__dots';

                dots.setAttribute(
                    'aria-label',
                    'Product image navigation'
                );

                slides.forEach(
                    (
                        slide,
                        index
                    ) => {
                        const dot =
                            document.createElement(
                                'button'
                            );

                        dot.type =
                            'button';

                        dot.className =
                            'product-gallery__dot';

                        dot.setAttribute(
                            'aria-label',
                            `Go to image ${index + 1}`
                        );

                        if (
                            index ===
                            0
                        ) {
                            dot.classList.add(
                                'is-active'
                            );
                        }

                        dot.addEventListener(
                            'click',
                            () => {
                                slide.scrollIntoView({
                                    behavior:
                                        'smooth',

                                    block:
                                        'nearest',

                                    inline:
                                        'start'
                                });
                            }
                        );

                        dots.appendChild(
                            dot
                        );
                    }
                );

                gallery.appendChild(
                    dots
                );

                let ticking =
                    false;

                track.addEventListener(
                    'scroll',
                    () => {
                        if (
                            ticking
                        ) {
                            return;
                        }

                        ticking =
                            true;

                        requestAnimationFrame(
                            () => {
                                const slideWidth =
                                    track.clientWidth ||
                                    1;

                                const index =
                                    Math.max(
                                        0,
                                        Math.min(
                                            slides.length -
                                            1,

                                            Math.round(
                                                track.scrollLeft /
                                                slideWidth
                                            )
                                        )
                                    );

                                dots
                                    .querySelectorAll(
                                        '.product-gallery__dot'
                                    )
                                    .forEach(
                                        (
                                            dot,
                                            i
                                        ) => {
                                            dot
                                                .classList
                                                .toggle(
                                                    'is-active',
                                                    i ===
                                                    index
                                                );
                                        }
                                    );

                                ticking =
                                    false;
                            }
                        );
                    },
                    {
                        passive:
                            true
                    }
                );
            }
        );

})();



/* =========================================================
   ENGLISH / ARABIC LANGUAGE
   AUTO-DETECT PHONE/BROWSER LANGUAGE ON FIRST VISIT
   MANUAL CHOICE ALWAYS WINS AFTER THE CUSTOMER CHANGES IT
========================================================= */

(() => {
    const AUTO_DONE_KEY =
        'laffan_language_auto_detected_v1';

    const MANUAL_LANGUAGE_KEY =
        'laffan_language_manual_v1';


    function safeStorageGet(
        key
    ) {
        try {
            return window.localStorage
                .getItem(
                    key
                );
        } catch (error) {
            return null;
        }
    }


    function safeStorageSet(
        key,
        value
    ) {
        try {
            window.localStorage
                .setItem(
                    key,
                    value
                );
        } catch (error) {
        }
    }


    function getCurrentStoreLanguage() {
        const htmlLanguage =
            document.documentElement
                .getAttribute(
                    'lang'
                );

        const shopifyLanguage =
            window.Shopify
                ?.language;

        return String(
            shopifyLanguage ||
            htmlLanguage ||
            'en'
        )
            .toLowerCase()
            .split('-')[0];
    }


    function getPreferredDeviceLanguage() {
        const languages =
            Array.isArray(
                navigator.languages
            ) &&
            navigator.languages.length
                ? navigator.languages
                : [
                    navigator.language ||
                    navigator.userLanguage ||
                    'en'
                ];

        const primaryLanguage =
            String(
                languages[0] ||
                'en'
            )
                .toLowerCase()
                .split('-')[0];

        return primaryLanguage ===
            'ar'
                ? 'ar'
                : 'en';
    }


    function findLanguageForm() {
        const switchButton =
            document.querySelector(
                '[data-language-switch]'
            );

        const buttonForm =
            switchButton
                ?.closest(
                    'form'
                );

        if (
            buttonForm &&
            buttonForm.querySelector(
                'input[name="language_code"]'
            )
        ) {
            return buttonForm;
        }


        return Array.from(
            document.querySelectorAll(
                'form'
            )
        ).find(
            form =>
                form.querySelector(
                    'input[name="language_code"]'
                )
        ) || null;
    }


    function submitLanguage(
        language
    ) {
        const targetLanguage =
            language ===
                'ar'
                ? 'ar'
                : 'en';

        const currentLanguage =
            getCurrentStoreLanguage();


        if (
            currentLanguage ===
            targetLanguage
        ) {
            return false;
        }


        const form =
            findLanguageForm();


        if (!form) {
            return false;
        }


        const input =
            form.querySelector(
                'input[name="language_code"]'
            );


        if (!input) {
            return false;
        }


        input.value =
            targetLanguage;


        form.submit();


        return true;
    }


    function autoDetectLanguage() {

        const manualLanguage =
            safeStorageGet(
                MANUAL_LANGUAGE_KEY
            );


        if (
            manualLanguage ===
                'ar' ||
            manualLanguage ===
                'en'
        ) {
            submitLanguage(
                manualLanguage
            );

            return;
        }


        const alreadyDetected =
            safeStorageGet(
                AUTO_DONE_KEY
            );


        if (
            alreadyDetected ===
            '1'
        ) {
            return;
        }


        const preferredLanguage =
            getPreferredDeviceLanguage();


        safeStorageSet(
            AUTO_DONE_KEY,
            '1'
        );


        submitLanguage(
            preferredLanguage
        );
    }


    document.addEventListener(
        'click',
        function (event) {

            const button =
                event.target.closest(
                    '[data-language-switch]'
                );


            if (!button) {
                return;
            }


            event.preventDefault();


            const current =
                String(
                    button.dataset
                        .currentLanguage ||
                    getCurrentStoreLanguage()
                )
                    .toLowerCase()
                    .split('-')[0];


            const targetLanguage =
                current ===
                    'ar'
                    ? 'en'
                    : 'ar';


            safeStorageSet(
                MANUAL_LANGUAGE_KEY,
                targetLanguage
            );


            safeStorageSet(
                AUTO_DONE_KEY,
                '1'
            );


            submitLanguage(
                targetLanguage
            );
        }
    );


    function startLanguageDetection() {

        window.setTimeout(
            autoDetectLanguage,
            40
        );

    }


    if (
        document.readyState ===
        'loading'
    ) {

        document.addEventListener(
            'DOMContentLoaded',
            startLanguageDetection,
            {
                once:
                    true
            }
        );

    } else {

        startLanguageDetection();

    }

})();


/* =========================================================
   REMOVE .00 / ,00 FROM STOREFRONT PRICES
========================================================= */

function cleanLaffanPrices(
    root = document
) {
    const selectors = [
        '.price',
        '.compare-price',
        '.product-price',
        '.price--large',
        '[data-product-price]',
        '[data-cart-total]',
        '[data-drawer-line-price]',
        '.predictive-item small'
    ];

    root
        .querySelectorAll(
            selectors.join(',')
        )
        .forEach(
            el => {
                const oldText =
                    el.textContent;

                const newText =
                    oldText
                        .replace(
                            /([.,]00)(?=\s*(QAR|ر\.?ق\.?)?\s*$)/i,
                            ''
                        )
                        .replace(
                            /(QAR\s*[\d,.]+)[.,]00\b/i,
                            '$1'
                        );

                if (
                    newText !==
                    oldText
                ) {
                    el.textContent =
                        newText;
                }
            }
        );
}


document.addEventListener(
    'DOMContentLoaded',
    () => {
        cleanLaffanPrices();
    }
);


const laffanPriceObserver =
    new MutationObserver(
        () => {
            cleanLaffanPrices();
        }
    );


laffanPriceObserver.observe(
    document.body,
    {
        childList:
            true,

        subtree:
            true
    }
);


// /* =========================================================
//    MOBILE PULL TO REFRESH
//    Added only as a new feature.
//    Existing theme.js code above is unchanged.
// ========================================================= */
//
// (() => {
//     const isTouchDevice =
//         'ontouchstart' in window ||
//         navigator.maxTouchPoints > 0;
//
//     if (!isTouchDevice) {
//         return;
//     }
//
//     if (
//         document.getElementById(
//             'LaffanPullToRefresh'
//         )
//     ) {
//         return;
//     }
//
//     const indicator =
//         document.createElement(
//             'div'
//         );
//
//     indicator.id =
//         'LaffanPullToRefresh';
//
//     indicator.setAttribute(
//         'aria-hidden',
//         'true'
//     );
//
//     indicator.innerHTML = `
//       <div class="laffan-ptr__bubble">
//         <span
//           class="laffan-ptr__icon"
//           data-ptr-icon
//         >
//           ↓
//         </span>
//
//         <span
//           class="laffan-ptr__text"
//           data-ptr-text
//         >
//           Pull to refresh
//         </span>
//       </div>
//     `;
//
//     document.body.appendChild(
//         indicator
//     );
//
//
//     if (
//         !document.getElementById(
//             'LaffanPullToRefreshStyles'
//         )
//     ) {
//         const style =
//             document.createElement(
//                 'style'
//             );
//
//         style.id =
//             'LaffanPullToRefreshStyles';
//
//         style.textContent = `
//           #LaffanPullToRefresh {
//             position: fixed;
//             top: 0;
//             left: 0;
//             right: 0;
//             z-index: 999999;
//
//             display: flex;
//             justify-content: center;
//
//             pointer-events: none;
//
//             opacity: 0;
//             transform: translateY(-64px);
//
//             transition:
//               opacity .12s ease,
//               transform .12s ease;
//           }
//
//           #LaffanPullToRefresh.is-visible {
//             opacity: 1;
//           }
//
//           #LaffanPullToRefresh .laffan-ptr__bubble {
//             min-height: 42px;
//             margin-top: max(8px, env(safe-area-inset-top));
//             padding: 9px 15px;
//
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             gap: 8px;
//
//             background: rgba(255,255,255,.97);
//             color: #173b2a;
//
//             border: 1px solid rgba(23,59,42,.13);
//             border-radius: 999px;
//
//             box-shadow: 0 7px 22px rgba(0,0,0,.12);
//
//             font-size: 13px;
//             font-weight: 800;
//
//             white-space: nowrap;
//           }
//
//           #LaffanPullToRefresh .laffan-ptr__icon {
//             display: inline-block;
//             font-size: 18px;
//             line-height: 1;
//
//             transform: rotate(0deg);
//             transition: transform .14s ease;
//           }
//
//           #LaffanPullToRefresh.is-ready .laffan-ptr__icon {
//             transform: rotate(180deg);
//           }
//
//           #LaffanPullToRefresh.is-refreshing .laffan-ptr__icon {
//             animation: laffanPtrSpin .7s linear infinite;
//           }
//
//           @keyframes laffanPtrSpin {
//             to {
//               transform: rotate(360deg);
//             }
//           }
//
//           @media (min-width: 990px) {
//             #LaffanPullToRefresh {
//               display: none !important;
//             }
//           }
//         `;
//
//         document.head.appendChild(
//             style
//         );
//     }
//
//
//     const icon =
//         indicator.querySelector(
//             '[data-ptr-icon]'
//         );
//
//     const label =
//         indicator.querySelector(
//             '[data-ptr-text]'
//         );
//
//
//     const isArabic =
//         String(
//             document.documentElement.lang ||
//             window.Shopify?.language ||
//             ''
//         )
//             .toLowerCase()
//             .startsWith('ar');
//
//
//     const strings = {
//         pull:
//             isArabic
//                 ? 'اسحب للتحديث'
//                 : 'Pull to refresh',
//
//         release:
//             isArabic
//                 ? 'اترك للتحديث'
//                 : 'Release to refresh',
//
//         refreshing:
//             isArabic
//                 ? 'جارٍ التحديث...'
//                 : 'Refreshing...'
//     };
//
//
//     const TRIGGER_DISTANCE =
//         92;
//
//     const MAX_DISTANCE =
//         132;
//
//
//     let startY =
//         0;
//
//     let currentDistance =
//         0;
//
//     let tracking =
//         false;
//
//     let refreshing =
//         false;
//
//
//     function pageIsAtTop() {
//         return (
//             window.scrollY <= 1 &&
//             document.documentElement.scrollTop <= 1
//         );
//     }
//
//
//     function shouldIgnoreTarget(
//         target
//     ) {
//         if (!(target instanceof Element)) {
//             return false;
//         }
//
//         return Boolean(
//             target.closest(
//                 [
//                     'input',
//                     'textarea',
//                     'select',
//                     '[contenteditable="true"]',
//                     '[data-cart-drawer]',
//                     '[data-mobile-menu]',
//                     '.delivery-map',
//                     '.leaflet-container',
//                     '.product-gallery__main',
//                     '[data-predictive-search-results]'
//                 ].join(',')
//             )
//         );
//     }
//
//
//     function resetIndicator() {
//         tracking =
//             false;
//
//         currentDistance =
//             0;
//
//         indicator.classList.remove(
//             'is-visible',
//             'is-ready',
//             'is-refreshing'
//         );
//
//         indicator.style.transform =
//             'translateY(-64px)';
//
//         if (icon) {
//             icon.textContent =
//                 '↓';
//         }
//
//         if (label) {
//             label.textContent =
//                 strings.pull;
//         }
//     }
//
//
//     document.addEventListener(
//         'touchstart',
//         event => {
//             if (
//                 refreshing ||
//                 event.touches.length !== 1 ||
//                 !pageIsAtTop() ||
//                 shouldIgnoreTarget(
//                     event.target
//                 )
//             ) {
//                 tracking =
//                     false;
//
//                 return;
//             }
//
//             startY =
//                 event.touches[0]
//                     .clientY;
//
//             currentDistance =
//                 0;
//
//             tracking =
//                 true;
//         },
//         {
//             passive:
//                 true
//         }
//     );
//
//
//     document.addEventListener(
//         'touchmove',
//         event => {
//             if (
//                 !tracking ||
//                 refreshing ||
//                 event.touches.length !== 1
//             ) {
//                 return;
//             }
//
//             if (!pageIsAtTop()) {
//                 resetIndicator();
//
//                 return;
//             }
//
//             const currentY =
//                 event.touches[0]
//                     .clientY;
//
//             const rawDistance =
//                 currentY -
//                 startY;
//
//             if (rawDistance <= 0) {
//                 resetIndicator();
//
//                 return;
//             }
//
//             currentDistance =
//                 Math.min(
//                     MAX_DISTANCE,
//                     rawDistance * .58
//                 );
//
//             if (
//                 currentDistance <
//                 8
//             ) {
//                 return;
//             }
//
//             if (
//                 event.cancelable
//             ) {
//                 event.preventDefault();
//             }
//
//             const visibleY =
//                 Math.min(
//                     58,
//                     currentDistance * .52
//                 );
//
//             indicator.classList.add(
//                 'is-visible'
//             );
//
//             indicator.style.transform =
//                 `translateY(${visibleY - 4}px)`;
//
//             const ready =
//                 currentDistance >=
//                 TRIGGER_DISTANCE;
//
//             indicator.classList.toggle(
//                 'is-ready',
//                 ready
//             );
//
//             if (label) {
//                 label.textContent =
//                     ready
//                         ? strings.release
//                         : strings.pull;
//             }
//         },
//         {
//             passive:
//                 false
//         }
//     );
//
//
//     document.addEventListener(
//         'touchend',
//         () => {
//             if (
//                 !tracking ||
//                 refreshing
//             ) {
//                 return;
//             }
//
//             tracking =
//                 false;
//
//             if (
//                 currentDistance <
//                 TRIGGER_DISTANCE
//             ) {
//                 resetIndicator();
//
//                 return;
//             }
//
//             refreshing =
//                 true;
//
//             indicator.classList.remove(
//                 'is-ready'
//             );
//
//             indicator.classList.add(
//                 'is-visible',
//                 'is-refreshing'
//             );
//
//             indicator.style.transform =
//                 'translateY(18px)';
//
//             if (icon) {
//                 icon.textContent =
//                     '↻';
//             }
//
//             if (label) {
//                 label.textContent =
//                     strings.refreshing;
//             }
//
//             window.setTimeout(
//                 () => {
//                     window.location.reload();
//                 },
//                 280
//             );
//         },
//         {
//             passive:
//                 true
//         }
//     );
//
//
//     document.addEventListener(
//         'touchcancel',
//         () => {
//             if (!refreshing) {
//                 resetIndicator();
//             }
//         },
//         {
//             passive:
//                 true
//         }
//     );
// })();